/**
 * Settings the public pages (reset password, invite) need in the browser —
 * the React admin's version of `src/lib/public-config.ts`.
 *
 * Values come from VITE_* variables compiled in at build time. They are
 * public (every visitor downloads them): never put a secret in one.
 */

/** The API is on this site's own address — the web server passes /api/v1 to the API server. */
export function apiBaseUrl(): string {
  return '/api/v1';
}

/** OneLink that opens the app (or the store) after a password reset. */
export const APP_ONELINK_URL: string =
  import.meta.env.VITE_APP_ONELINK_URL ||
  'https://fincurry.onelink.me/exBF?deep_link_value=login&af_force_deeplink=true';

/** AppsFlyer OneLink template + subdomain for invite links. Each environment has its own. */
export const INVITE_ONELINK = {
  templateId: (import.meta.env.VITE_APPSFLYER_ONELINK_ID as string | undefined) || 'exBF',
  subdomain: (import.meta.env.VITE_APPSFLYER_ONELINK_SUBDOMAIN as string | undefined) || 'fincurry',
};

/** The link that opens an invite in the app (deferred deep link after install). */
export function inviteOneLinkUrl(token: string, groupName: string): string {
  const { subdomain, templateId } = INVITE_ONELINK;
  return `https://${subdomain}.onelink.me/${templateId}?deep_link_value=invite_${token}&deep_link_sub1=${encodeURIComponent(groupName)}&af_force_deeplink=true`;
}
